import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Bank2 = ({ size = 20, style, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, ...style }}
    >
      <g clipPath="url(#clip0_975_13527)">
        <path d="M4.99967 7.91663H3.33301V13.75H4.99967V7.91663Z" fill={fill} />
        <path d="M9.99967 7.91663H8.33301V13.75H9.99967V7.91663Z" fill={fill} />
        <path
          d="M17.4997 4.58329L9.16634 0.416626L0.833008 4.58329V6.24996H17.4997V4.58329ZM4.55801 4.58329L9.16634 2.28329L13.7747 4.58329H4.55801Z"
          fill={fill}
        />
        <path
          d="M0.833008 15.4166V17.0833H11.1663C10.9913 16.55 10.8997 15.9916 10.8663 15.4166H0.833008Z"
          fill={fill}
        />
        <path d="M14.9997 9.79996V7.91663H13.333V10.6333L14.9997 9.79996Z" fill={fill} />
        <path
          d="M15.833 11.25L12.4997 12.9166V15.0416C12.4997 17.1416 13.9247 19.1083 15.833 19.5833C17.7413 19.1083 19.1663 17.1416 19.1663 15.0416V12.9166L15.833 11.25ZM15.233 17.0833L13.5413 15.3916L14.4247 14.5083L15.233 15.3166L17.2413 13.3333L18.1247 14.2166L15.233 17.0833Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_975_13527">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
